export default {
		apiBaseUrl: 'https://api.medau-therapie.de/api',
    imageBaseUrl: 'https://api.medau-therapie.de',
    apiKey: 'ffa690e93d916d5042052009e9b22cf54d4f9fa41400096ef84f0a44a2c1e441418e16ee00fbe21cbe3bb315e2ee659766339ffe2af6dba3b400987b2c78f46e5f33438d929e392ef342e674b2a1fb4203016ef1d3ae4614125aeb3f4057bdf0c37090531367dc965c6c31f3901205193c6a6e83efeff107c1d855dab4374c64',
}
